<template>
    <vue-context ref="copyMenu">
      <li>
        <b-link class="d-flex align-items-center" @click="copySelectedText">
          <feather-icon icon="CopyIcon" size="16" />
          <span class="ml-75">{{ $t('others.copy') }}</span>
        </b-link>
      </li>
    </vue-context>
  </template>
  
  <script>
  export default {
    name: 'ContextCopyMenu',
    data() {
      return {
        selectedRow: null, 
      };
    },
    methods: {
      openContextMenu(event, selectedRow) {
        console.log('event,', event)
        console.log('selectedRow,', selectedRow)
        this.selectedRow = selectedRow;
        this.$refs.copyMenu.open(event); 
      },
      copySelectedText() {
        if (!this.selectedRow) return;
        const note = this.selectedRow || '';
        const nameOnly = note.split(' - ')[0];
        navigator.clipboard.writeText(nameOnly).then(() => {
          this.$SuccessAlert(`${this.$t('others.copied')}:\n${nameOnly}`);
        }).catch(err => {
          this.$WarningAlert(this.$t('others.copy_failed'));
          console.error('Copy failed: ', err);
        });
        this.$refs.copyMenu.close();
      },
    },
  };
  </script>
  